export function formatDateLocal (date) {
  if (!date) {
    return
  }
  if (typeof date === 'number') {
    date = new Date(date * 1000)
  }
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  const month = date.getMonth() + 1
  const day = date.getDate()

  let result = `${date.getFullYear()}年`

  if (month > 9) {
    result += `${month}年`
  } else {
    result += `0${month}年`
  }

  if (day > 9) {
    result += `${day}日`
  } else {
    result += `0${day}日`
  }

  if (hours > 9) {
    result += `${hours}点`
  } else {
    result += `0${hours}点`
  }

  if (minutes > 9) {
    result += `${minutes}分`
  } else {
    result += `0${minutes}分`
  }

  if (seconds > 9) {
    result += `${seconds}秒`
  } else {
    result += `0${seconds}秒`
  }

  return result
}

export function formatDateStr (date) {
  if (!date) {
    return
  }
  if (typeof date === 'number') {
    date = new Date(date * 1000)
  }

  const month = date.getMonth() + 1
  const day = date.getDate()

  let result = `${date.getFullYear()}`

  if (month > 9) {
    result += `-${month}`
  } else {
    result += `-0${month}`
  }

  if (day > 9) {
    result += `-${day}`
  } else {
    result += `-0${day}`
  }

  return result
}
